<div class="pwd-guard">
    <form name="form" #f="ngForm">
        <div class="flex flex-col">
            <div>
                <input #password="ngModel" [(ngModel)]="loginPassword" name="password" type="password" class="input" required />
                <label class="pl-4">Password</label>
                <div *ngIf="pwdError" class="text-red-600">
                    <p>Invalid</p>
                </div>
            </div>

            <button (click)="login()" type="submit" class="btn">Verify</button>
        </div>
    </form>
</div>
